module.exports = __webpack_public_path__ + "img/aboutLogo_hm.5169a9c6.png";